/**
 * @file   查找相似图片
 * @create macaiqi 2021/07/30
 * @update
 */
import React, { useEffect, useState, useMemo, useRef, useCallback } from 'react';
import { Link } from 'react-router-dom';
import usePage from '../../../components/Hooks/usePage';
import { GetQueryString } from '../../../../utils';
import { queryFileInfoList } from '../../../shared/api';
import Bread from '../../common/Bread';
import cls from 'classnames';
import Macy from 'macy';
import { SketchPicker } from 'react-color';
// import LazyLoad from 'react-lazyload';
import './index.scss';
import { useHistory } from 'react-router';
import Loading from '../../../components/Loading';
import BigImgShow from '../ImgDetail/BigImgShow';
import Star from '../../common/Star';

const Verticalfigure = ({ hideleft, data, loading, size }) => {
  const macyrender = useRef();
  const [mymacy, setMymacy] = useState();
  const history = useHistory()

  useEffect(() => {
    if (mymacy) {
      mymacy.reInit();
      mymacy.runOnImageLoad(function() {
        mymacy.recalculate(true);
      }, true);
    } else {
      setMymacy(
        Macy({
          container: macyrender.current, // 图像列表容器
          trueOrder: false,
          waitForImages: false,
          useOwnImageLoader: false,
          debug: true,
          margin: { x: 14, y: 14 }, // 设计列与列的间距
          columns: 6,
          // 定义不同分辨率（1200，940，520，400这些是分辨率）
          breakAt: {
            1920: 4,
            1750: 4,
            1360: 4,
            1200: 4,
            940: 3,
            520: 3,
            400: 2
          }
        })
      );
    }
  }, [loading, mymacy, size]);

  return (
      <div className="macy-container" ref={macyrender}>
        {data?.records?.map((item, index) => {
          return (
            <div className='imgBox'
              key={index}
              target="_blank"
            >
              {/* <LazyLoad> */}
              <Link className='map' to={`/PicturelistPage/${item.instanceId}?fileInfoId=${item.fileInfoId}&hasMark=1`} target='_blank'>
                <img
                  src={`${window.ENV_IMG_PREURL_SRC}/${item.fileThumbnail}`}
                  alt=""
                  title={item.fileName}
                />
              </Link>
              {/* </LazyLoad> */}

              <div className="markNum">
                知识标记<span>{item.markSum}</span>条
              </div>
              <div className='text'>
                <span className='name' title={item.fileName}>{item.fileName}</span>
                <Star operationType = '2' instanceId={item?.instanceId} fileInfoId={item?.fileInfoId}/>
              </div>
            </div>
          );
        })}
      </div>
  );
  // return loading ? (
  //   <Loading />
  // ) : (
  //   <div className="macy-container" ref={macyrender}>
  //     {data?.records?.map((item, index) => {
  //       return (
  //         <Link to={`/PicturelistPage/${item.instanceId}`} key={index}>
  //           <img
  //             src={`${window.ENV_IMG_PREURL_SRC}/${item.fileThumbnail}`}
  //             alt=""
  //             title={item.fileName}
  //           />
  //           <div className="num">{item.markSum}</div>
  //         </Link>
  //       );
  //     })}
  //   </div>
  // );
};
// 左边筛选栏目
const Box = (props) => {
  const box = useRef();
  return (
    <div className="box" ref={box}>
      {props.children}
    </div>
  );
};
// 首页
const PicturelistPage = () => {
  const [hideleft, setHideleft] = useState(); // 左边显示隐藏
  const [havecolor, setHavecolor] = useState(); // 颜色选择
  const [searchType, setSearchType] = useState(0); // 搜索类型
  const [color, setcolor] = useState(); // 颜色选择
  const [cleancolor, setcleancolor] = useState(); // 颜色清除
  const [showColor, setShowColor] = useState(false); // 是否展示选择颜色组件

  const [data, setData] = useState();
  const [initPage, setPage] = usePage(GetQueryString('page'));

  // 颜色切换
  const handleChangeColor = (mycolor) => {
    setHavecolor(mycolor);
  };

  const [size, setSize] = useState(20);
  const [val, setVal] = useState();
  const [key, setKey] = useState();
  const [loading, setloading] = useState(true);
  const tabr = [{ title: '智能排序' }, { title: '收藏多' }, { title: '点赞多' }, { title: '标注多' }];
  const typeNav = [{ title: '全部' }, { title: '民居' }, { title: '祠堂' }, { title: '牌坊' }, { title: '木雕' }, { title: '砖雕' }, { title: '石雕' }, { title: '其他' }]
  const [type,setType] = useState('全部');
  const [showType, setShowType] = useState(false); // 是否展示选择分类组件
  // // console.log(GetQueryString('key'));
  const params = useMemo(() => {
    return {
      color: color?.rgb ? `${color.rgb.r + ',' + color.rgb.g + ',' + color.rgb.b}` : null,
      current: 1,
      fileName: key,
      searchType: searchType,
      size: size,
      type: type == '全部' ? '' : type
    };
  }, [size, color, searchType, key,type]);

  useEffect(() => {
    searchDatas();
  }, [params]);

  const searchDatas = () => {
    setloading(true);
    queryFileInfoList(params).then((res) => {
      setData(res);
      setloading(false);
    });
  }

  useEffect(() => {
    window.onscroll = function() {
      let scrollT =
        document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
      if (scrollT + document.body.clientHeight >= document.documentElement.scrollHeight - 500) {
        // 距离底部500开始加载
        setTimeout(() => {
          if (size <= data?.total) {
            if (!loading) {
              setSize(size + 20);
            }
          }
        }, 800);
      }
    };
  }, [size, data, loading]);

  const handleKeyDown = useCallback(
    (e) => {
      if (e.charCode === 0 && e.keyCode === 13) {
        e.preventDefault();
        setKey(val);
      }
    },
    [val]
  );
  const isInitImg = true;
  return (
    <div className='rootDiv'>
      <BigImgShow isInitImg={isInitImg}/>
      <div className="piclist-page">
        {/* <Bread title="影像探索" /> */}
        <div className="allcenter">
          {/* <div className={cls('l', { hide: hideleft })}>
            <div
              className="top"
              onClick={() => {
                setHideleft(!hideleft);
              }}
            >
              <i className="iconfont icon-filter2" />
              {hideleft ? '展开筛选条件' : '收起筛选条件'}
            </div>
            <div className="choose">
              <Box name="色彩">
                <div className="colorline">
                  <div
                    className="normal"
                    onClick={() => {
                      // 默认颜色
                      setHavecolor();
                      setcleancolor(true);
                      // setcolor();
                    }}
                  />
                  <div
                    className={cls('btn', { active: havecolor || cleancolor })}
                    onClick={() => {
                      // console.log(havecolor);
                      setHavecolor();
                      setcolor(havecolor);
                      setPage(1);
                      setcleancolor(false);
                    }}
                  >
                    确定
                  </div>
                </div>
                <SketchPicker
                  color={havecolor || color}
                  onChangeComplete={handleChangeColor}
                  presetColors={[
                    '#364564',
                    '#3379b7',
                    '#5CB85C',
                    '#A58061',
                    '#F0AD4E',
                    '#D9534F',
                    '#AC27B1',
                    '#17AEB0',
                    '#BEBEBE',
                    '#282828'
                  ]}
                />
              </Box>
            </div>
          </div> */}
          <div className="r">
            <div className='r-top'>
              <div className='r-center'>
              <div className="search">
                <input
                  type="text"
                  value={val}
                  onChange={(e) => {
                    setVal(e.target.value);
                  }}
                  onKeyDown={handleKeyDown}
                />
                <i
                  className="iconfont icon-sousuo"
                  onClick={() => {
                    setKey(val);
                    // searchDatas();
                  }}
                />
              </div>
              {/* <div className='type' onMouseEnter={()=>{setShowType(true);}}>
                <div className='key'>
                  分类：{type}<i className="iconfont icon-jiantouxia"/>
                </div>
                <div className={cls('l-nav',{show:showType})} onMouseLeave={()=>{setShowType(false);}}>
                  {typeNav?.map((item, index) => {
                    return (
                      <div className={cls("select", { 'active': item.title === type })} key={index} 
                      onClick={()=>{
                        setType(item.title);
                        setShowType(false);
                      }}>
                        {item.title}
                      </div>
                    )
                  })}
                </div>
              </div> */}
              <div className='type' onMouseEnter={()=>{setShowColor(true);}}>
                <div className='key'>
                  色彩：
                  <div className="normal"/>
                  <i className="iconfont icon-jiantouxia"/>
                </div>
                <div className={cls('choose',{show:showColor})} onMouseLeave={()=>{setShowColor(false);}}>
                  <Box name="色彩">
                    <div className="colorline">
                      <div
                        className="normal"
                        onClick={() => {
                          // 默认颜色
                          setHavecolor();
                          setcleancolor(true);
                        }}
                      />
                      <div
                        className={cls('btn', { active: havecolor || cleancolor })}
                        onClick={() => {
                          setHavecolor();
                          setcolor(havecolor);
                          setPage(1);
                          setcleancolor(false);
                          setShowColor(false);
                        }}
                      >
                        确定
                      </div>
                    </div>
                    <SketchPicker
                      color={havecolor || color}
                      onChangeComplete={handleChangeColor}
                      presetColors={[
                        '#364564',
                        '#3379b7',
                        '#5CB85C',
                        '#A58061',
                        '#F0AD4E',
                        '#D9534F',
                        '#AC27B1',
                        '#17AEB0',
                        '#BEBEBE',
                        '#282828'
                      ]}
                    />
                  </Box>
                </div>
              </div>
              <div className="tab">
                <div className='key'>排序方式：</div>
                {tabr.map((item, index) => {
                  return (
                    <div
                      className={cls('item', { active: searchType === index })}
                      key={index}
                      onClick={() => {
                        setSearchType(index);
                      }}
                    >
                      <span>{item.title}</span>
                    </div>
                  );
                })}
              </div>
              </div>
            </div>

            {data?.total === 0 && <p className="num">暂无相关素材</p>}
            <Verticalfigure size={size} hideleft={hideleft} data={data} loading={loading} />
            {loading && <Loading />}
            {/* {data?.totalPage > 1 && (
            <Pager
              containerClassName="mypager"
              forcePage={initPage || 1}
              pageCount={data?.pages}
              total={data?.total}
              onPageChange={(page) => setPage(page)}
              showLast={false}
              showFirst={false}
              prevLabel=""
              nextLabel=""
              // showTotal
            />
          )} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PicturelistPage;
